var app = {
    init: function () {
        app.functionActiveUrl();

    },

    functionCarousel: function () {
        $(".carousel--two").owlCarousel({
            loop: true,
            autoplay: true,
            margin: 20,
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 2
                },
                1000: {
                    items: 3
                }
            }
        });
    },
    functionActiveUrl: function () {
        var url = window.location;
        $(".nav-link").each(function () {
            if (this.href == url) {
                $(this).addClass("active");
            }
        });
    },
};

$("document").ready(function () {
    app.init();

    $(".carousel").carousel();

    $(document).on('scroll', function () {
        var $nav = $(".fixed-top");
        $nav.toggleClass("scrolled", $(this).scrollTop() > $nav.height());
    });

    $("input[required], select[required], textarea[required]")
        .siblings("label")
        .addClass("required");

    Inputmask("999.999.999-99").mask("[data-mask='cpf']");
    Inputmask("9", {
        repeat: 15
    }).mask("[data-mask='sus']");
    Inputmask("9", {
        repeat: 11
    }).mask("[data-mask='nis']");
    Inputmask("(99) 99999-9999").mask("[data-mask='phone']");
    Inputmask("99999-999").mask("[data-mask='zip-code']");
    Inputmask("99/99/9999").mask("[data-mask='date']");

    $(".select2").select2({
        language: "pt-BR",
        placeholder: "Selecione...",
        width: "100%",
        theme: 'bootstrap-5',
        allowClear: true
    });

    $("#zip_code").blur(function () {
        //Nova variável "cep" somente com dígitos.
        var cep = $(this)
            .val()
            .replace(/\D/g, "");

        //Verifica se campo cep possui valor informado.
        if (cep != "") {
            //Expressão regular para validar o CEP.
            var validacep = /^[0-9]{8}$/;

            //Valida o formato do CEP.
            if (validacep.test(cep)) {
                //Preenche os campos com "..." enquanto consulta webservice.
                $("#street").val("...");
                $("#complement").val("...");

                //Consulta o webservice viacep.com.br/
                $.getJSON(
                    "https://viacep.com.br/ws/" + cep + "/json/?callback=?",
                    function (dados) {
                        if (!("erro" in dados)) {
                            //Atualiza os campos com os valores da consulta.
                            $("#street").val(dados.logradouro);
                            $("#complement").val(dados.complemento);
                        } //end if.
                        else {
                            //CEP pesquisado não foi encontrado.

                            swal("Atenção", "CEP não encontrado.", "warning");
                        }
                    }
                );
            } //end if.
            else {
                swal("Atenção", "Formato de CEP inválido.", "warning");
            }
        } //end if.
    });
});
